module.exports = __webpack_public_path__ + "img/83.ea21fda2.jpg";